<template>
  <div style="min-height:100vh">
    <v-overlay absolute :opacity="0.75" v-if="loading">
      <div class="text-center">
        <v-progress-circular :size="100" indeterminate></v-progress-circular>
        <div class="caption mt-4">Loading</div>
      </div>
    </v-overlay>
    <v-dialog
      v-model="show_access_code_dialog"
      persistent
      :overlay-opacity="1"
      overlay-color="secondary"
      :max-width="400"
    >
      <v-card>
        <v-card-title class="blue white--text">Access restricted</v-card-title>
        <v-card-text class="py-6">
          <form autocomplete="off">
            <v-text-field
              v-model="access_code"
              type="text"
              id="portal-password"
              label="Enter access code"
              autocomplete="access-code"
              hide-details
              v-on:keyup.enter="load"
            ></v-text-field>
          </form>

          <div class="text-center pt-3">
            <span v-if="access_code_invalid" class="error--text">Invalid access code</span>
          </div>
        </v-card-text>
        <v-card-actions class="grey lighten-4">
          <v-btn text to="/">Go Home</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="blue" dark @click="load" :disabled="!access_code">Submit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="show_error_dialog"
      persistent
      :overlay-opacity="1"
      overlay-color="secondary"
      :max-width="400"
    >
      <v-card>
        <v-card-title class="primary white--text">
          Portal unavailable
          <v-spacer></v-spacer>
          <v-icon dark>fa-exclamation-triangle</v-icon>
        </v-card-title>
        <v-card-text class="py-6">
          <div class="text-center pt-3">
            <h3 class>{{error_message}}</h3>
          </div>
        </v-card-text>
        <v-card-actions class="grey lighten-4">
          <v-spacer></v-spacer>
          <v-btn text to="/">Go Home</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div>
      <transition name="slide-x-reverse-transition">
        <v-container id="applicant-portal" v-if="portal">
          <v-row justify="center">
            <v-col cols="11" sm="10" md="9" lg="8" xl="6">
              <v-container>
                <div>
                  <v-row justify="center" style="position:relative">
                    <v-col cols="12" sm="11" md="10" lg="9" xl="7" class="text-center">
                      <div>
                        <img
                          :title="portal.logo.name"
                          :src="portal.logo.url"
                          style="width:100%;max-width:375px;height:auto"
                          @click="$emit('logo-upload')"
                        />
                      </div>
                    </v-col>
                    <v-col cols="12" v-if="portal.video">
                      <video
                        playsinline
                        style="width:100%;height:auto;max-height:66vh;margin-bottom:-8px"
                        :src="portal.video.url"
                        :poster="portal.video.thumbnail"
                        controls
                      ></video>
                    </v-col>
                  </v-row>
                </div>
                <div id="portal-info" v-if="portal.title || portal.description">
                  <v-row>
                    <v-col cols="12">
                      <h3>{{portal.title}}</h3>
                      <p class="caption">{{portal.description}}</p>
                    </v-col>
                  </v-row>
                </div>

                <div id="applicant-info">
                  <v-form autocomplete="off">
                    <v-row justify="center">
                      <v-col cols="12" class="py-2">
                        <v-text-field
                          dense
                          outlined
                          hide-details
                          name="name"
                          label="Name"
                          required
                          autocomplete="off"
                          v-model="applicant.name"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" class="py-2">
                        <v-text-field
                          dense
                          outlined
                          hide-details
                          required
                          name="email"
                          label="Email"
                          type="email"
                          inputmode="email"
                          v-model="applicant.email"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" class="py-2" v-if="portal.require.phone">
                        <v-text-field
                          dense
                          outlined
                          hide-details
                          required
                          name="phone"
                          label="Phone #"
                          type="tel"
                          inputmode="tel"
                          v-model="applicant.phone"
                        ></v-text-field>
                        <!--
                        <vue-phone-number-input
                          v-model="phone_raw"
                          :show-code-on-list="false"
                          @update="setPhone"
                          required
                          size="lg"
                          :preferred-countries="['CA','US','AU','GB']"
                          style="z-index:100"
                        ></vue-phone-number-input>
                        !-->
                      </v-col>
                    </v-row>
                  </v-form>
                </div>

                <div id="portal-sections">
                  <v-row>
                    <v-col cols="12" v-for="(section,s) in portal.sections" :key="s">
                      <portal-section :value="section" :portal="portal" :access_code="access_code"></portal-section>
                    </v-col>
                  </v-row>
                </div>
                <div id="error-messages">
                  <v-row>
                    <v-col cols="12" class="text-center">
                      <div
                        class="error--text"
                        v-for="(message,m) in errMessages"
                        :key="`err-message-${m}`"
                      >
                        <span class="caption">*{{message}}</span>
                      </div>
                    </v-col>
                  </v-row>
                </div>
                <div id="portal-terms" v-if="portal.require.conditions && portal.conditions">
                  <v-row justify="space-around" class="py-4">
                    <v-checkbox
                      class="mt-0"
                      @click="show_terms=true"
                      :value="applicant.agree_terms"
                      color="blue"
                      readonly
                      hide-details
                      label="Agree to terms & conditions"
                    ></v-checkbox>
                    <v-dialog v-model="show_terms" :max-width="600" scrollable>
                      <v-card>
                        <v-card-title class="secondary white--text">Terms & Conditions</v-card-title>
                        <v-card-text
                          class="py-4"
                          style="max-height:500px"
                          v-html="portal.conditions"
                        ></v-card-text>
                        <v-card-actions class="grey lighten-3">
                          <v-spacer></v-spacer>
                          <v-checkbox
                            color="blue"
                            v-model="applicant.agree_terms"
                            label="I agree"
                            @change="agreeTerms"
                          ></v-checkbox>
                          <v-spacer></v-spacer>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-row>
                </div>

                <div id="portal-submit">
                  <v-row justify="space-around">
                    <v-col class="text-center" cols="12">
                      <v-btn
                        x-large
                        color="blue"
                        :dark="canSubmit"
                        @click="submit"
                        :disabled="!canSubmit"
                      >Submit</v-btn>
                    </v-col>
                  </v-row>
                </div>
              </v-container>
            </v-col>
          </v-row>
        </v-container>
      </transition>
    </div>
  </div>
</template>

<script>
import portalSection from "@/components/portal/applicant/section";

export default {
  name: "Applicant",
  components: {
    portalSection,
  },
  data() {
    return {
      loading: false,
      phone_raw: "",
      applicant: {
        name: "",
        email: "",
        phone: "",
        agree_terms: false,
      },
      show_terms: false,
      access_code: "",
      access_code_required: false,
      access_code_invalid: false,
      show_access_code_dialog: false,
      error_message: "",
      show_error_dialog: false, //Shows a popup saying the portal is unavailable. (user account is bad or portal isnt active)
      portal: null,
    };
  },
  computed: {
    canSubmit() {
      if (this.errMessages.length) {
        return false;
      }
      if (
        this.portal.require.conditions &&
        this.applicant.agree_terms === false
      ) {
        return false;
      }
      if (this.$store.state.applicant_uploads.length > 0) {
        return false;
      }
      return true;
    },
    errMessages() {
      let list = [];
      if (!this.applicant.name) {
        list.push("Name required");
      } else if (this.applicant.name.split(" ").length === 1) {
        list.push("Full name required");
      }
      if (!this.applicant.email) {
        list.push("Email required");
      } else if (!this.$helpers.validEmail(this.applicant.email)) {
        list.push("Invalid email");
      }
      if (this.portal.require.phone && !this.applicant.phone) {
        list.push("Phone # required");
      }
      if (this.portal.require.all_sections) {
        console.log("all_sections");
        this.portal.sections.forEach((section) => {
          console.log("section", section);
          if (section.videos.required && !section.videos.files.length) {
            list.push(
              `${section.title} ${
                section.videos.multiple ? "videos" : "video"
              } required`
            );
          } else if (section.photos.required && !section.photos.files.length) {
            list.push(
              `${section.title} ${
                section.photos.multiple ? "photos" : "photo"
              } required`
            );
          } else if (
            section.documents.required &&
            !section.documents.files.length
          ) {
            list.push(
              `${section.title} ${
                section.documents.multiple ? "documents" : "document"
              } required`
            );
          }
        });
      }
      return list;
    },
  },
  created() {
    this.load();
  },
  methods: {
    setPhone(ew) {
      this.applicant.phone = ew.e164;
    },
    agreeTerms() {
      this.show_terms = false;
    },
    async submit() {
      this.loading = true;
      try {
        let response = await this.$api.post(
          `/applicant/portal/${this.$route.params.uid}?access_code=${this.access_code}`,
          {
            applicant: this.applicant,
            sections: this.portal.sections,
          },
          {
            headers: {
              session_uid: this.portal.session_uid,
            },
          }
        );
        this.$eventBus.$emit("applicant-success");
        this.$router.push(`/applicant-view/${response.uid}`);
      } catch (ex) {
        alert(ex.error);
      }
      this.loading = false;
    },
    async load() {
      this.loading = true;
      this.access_code_invalid = false;

      try {
        let response = await this.$api(
          `/applicant/portal/${this.$route.params.uid}?access_code=${this.access_code}`
        );
        if (response.access_code_required) {
          this.access_code_required = true;
          this.show_access_code_dialog = true;
          if (response.access_code_invalid) {
            this.access_code = "";
            this.access_code_invalid = true;
          }
        } else {
          this.portal = response;
          this.show_access_code_dialog = false;
        }
      } catch (ex) {
        this.error_message = ex.error;
        this.show_error_dialog = true;
      }
      this.loading = false;
    },
  },
};
</script>

<style>
</style>